import { Text } from '@ltvco/refresh-lib/theme';

import { constants } from 'appConstants';

import { BannerContainer, StyledBannerIcon } from './styledComponents';

export const NoNotificationsBanner = () => {
  const imgNotificationBanner = constants?.images?.imgNotificationBanner;

  return (
    <BannerContainer
      sx={{
        padding: {
          xs: '20px 0px',
          sm: '20px 16px',
        },
      }}
    >
      <StyledBannerIcon src={imgNotificationBanner} alt="" />
      <Text variant="body1" color="text.primary" marginBottom={0}>
        You're all caught up — no notifications right now
      </Text>
    </BannerContainer>
  );
};

export default NoNotificationsBanner;
